// @flow
import { graphqlClient } from 'bk-web-app';

import generateRequest from './generateRequest';
import { GET_CLIENT_REQUEST_DATA } from './queries';

const generateRequestForClient = (clientId: string): Promise<string> =>
  graphqlClient
    .query({ fetchPolicy: 'network-only', query: GET_CLIENT_REQUEST_DATA, variables: { clientId } })
    .then(({ data }) =>
      generateRequest({ ...data.client, unifiedBankingEnabled: data.unifiedBankingEnabled }),
    );

export default generateRequestForClient;
